import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, ArrowRight, CheckCircle, Phone, Mail } from 'lucide-react';
import InquiryForm from '../components/home/InquiryForm';
import WhatsAppFloatingButton from '../components/layout/WhatsAppFloatingButton';

// Import local image
import familyMattersImg from '../assets/family-matters.png';

const FamilyMatters = () => {
  const services = [
    "Divorce, Maintenance, and Alimony",
    "Child Custody & Guardianship",
    "Domestic Violence Cases",
    "Property Disputes within Families",
    "Negotiation and Settlement for amicable resolutions"
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-primary-blue min-h-[35vh] flex items-center">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60"
          style={{ backgroundImage: `url(${familyMattersImg})` }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center text-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">Family Matters</h1>
              <p className="text-xl text-gray-300">Compassionate guidance for you and your family</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Left Column - Services */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h2 className="text-3xl font-bold text-primary-blue mb-6">Our Services</h2>
              <div className="space-y-4">
                {services.map((service, index) => (
                  <div key={index} className="flex items-start p-4 bg-gray-50 rounded-lg hover:bg-gold hover:bg-opacity-5 transition-colors">
                    <CheckCircle className="w-6 h-6 text-gold mr-3 flex-shrink-0 mt-0.5" />
                    <span className="text-dark-gray text-lg">{service}</span>
                  </div>
                ))}
              </div>

              {/* Contact Info */}
              <div className="mt-8 pt-8 border-t border-gray-200">
                <h3 className="text-xl font-bold text-primary-blue mb-4">Let’s connect</h3>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a href="tel:+919769415432" className="flex items-center text-dark-gray hover:text-gold">
                    <Phone className="w-5 h-5 mr-2 text-gold" /> +91 97694 15432
                  </a>
                  <a href="mailto:akylegalconsultants@gmail.com" className="flex items-center text-dark-gray hover:text-gold">
                    <Mail className="w-5 h-5 mr-2 text-gold" /> akylegalconsultants@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Inquiry Form */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-24">
              <h3 className="text-2xl font-bold text-primary-blue mb-6 text-center">
                Free Consultation
              </h3>
              <InquiryForm />
            </div>
          </div>
        </div>

        {/* Back to Home Button */}
        <div className="text-center mt-12">
          <Link
            to="/"
            className="inline-flex items-center text-primary-blue hover:text-gold font-semibold"
          >
            <ArrowRight className="w-5 h-5 mr-2 rotate-180" />
            Back to Home
          </Link>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <WhatsAppFloatingButton />
    </div>
  );
};

export default FamilyMatters;
